module.exports = __webpack_public_path__ + "static/media/youtube.55e2c943.svg";